// extracted by mini-css-extract-plugin
export var blockedMessage = "_88-3";
export var blockedOverlay = "_88-1";
export var fadeIn = "_88-2";
export var hereLink = "_88-0";
export var slideUp = "_88-4";